<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="section">
      <div class="columns">
        <div class="column is-3"></div>
        <div class="column is-5">Frame No: <input type="text" class="input" name="frameNo" v-model="frameNo" style="width:80%"></div>
        <div class="column is-1"><button  class="button is-danger" id="submit-button" name="submit-button" v-on:click="searchCar" >Search</button></div>
      </div>

      <h3 class="title" v-show="dataAlready" style="background-color:#eee;padding:15px;text-align:left;font-size:23px;">ข้อมูล Jobs GR</h3>
      <div class="container">
          <span v-show="!dataAlready && startSearch">Loading....</span>
          <table class="table is-striped" style="width:100%" v-show="dataAlready">
              <thead>
                  <tr>
                    <th><abbr title="name">ชื่อลูกค้า</abbr></th>
                    <th><abbr title="licenseNo">เลขทะเบียน</abbr></th>
                    <th><abbr title="userId">สาขา</abbr></th>
                    <th><abbr title="userId">เลข Job</abbr></th>
                    <th><abbr title="userId">วัน-เวลารับรถ</abbr></th>
                    <th><abbr title="userId">วัน-เวลาแก้ไขล่าสุด</abbr></th>
                    <th><abbr title="userId">สถานะงานซ่อม</abbr></th>
                    <th><abbr title="userId">รูป LINE</abbr></th>
                    <th><abbr title="userId">ชื่อ LINE</abbr></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="car in jobList.item">
                  <tr v-bind:key="car.id" v-if="car.userId != '' && car.userId != '-1' ">
                    <td>{{car.customerName}}</td>
                    <td>{{car.licenseNo}}</td>
                    <td>{{car.branchId}}</td>
                    <td>{{car.runNo}}</td>
                    <td>{{formatDate(car.createdAt)}}</td>
                    <td>{{formatDate(car.updatedAt)}}</td>
                    <td>{{car.status}}</td>
                    <td><img :src="car.user.pictureUrl" width="100"></td>
                    <td><a href="#" @click="msgUser=car.user;openSendMsg=true">{{car.user.displayName}}</a></td>
                  </tr>
                </template>
              </tbody>
          </table>
      </div><br><br>
      <h3 class="title" v-show="dataAlready" style="background-color:#eee;padding:15px;text-align:left;font-size:23px;">ข้อมูล Jobs BP</h3>
      <div class="container">
          <span v-show="!dataAlready && startSearch">Loading....</span>
          <table class="table is-striped" style="width:100%" v-show="dataAlready">
              <thead>
                  <tr>
                    <th><abbr title="name">ชื่อลูกค้า</abbr></th>
                    <th><abbr title="licenseNo">เลขทะเบียน</abbr></th>
                    <th><abbr title="userId">สาขา</abbr></th>
                    <th><abbr title="userId">เลข Job</abbr></th>
                    <th><abbr title="userId">วัน-เวลารับรถ</abbr></th>
                    <th><abbr title="userId">วัน-เวลาแก้ไขล่าสุด</abbr></th>
                    <th><abbr title="userId">สถานะงานซ่อม</abbr></th>
                    <th><abbr title="userId">รูป LINE</abbr></th>
                    <th><abbr title="userId">ชื่อ LINE</abbr></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="car in jobBPList.item">
                  <tr v-bind:key="car.id" v-if="car.userId != '' && car.userId != '-1' ">
                    <td>{{car.customerName}}</td>
                    <td>{{car.licenseNo}}</td>
                    <td>{{car.branchId}}</td>
                    <td>{{car.runNo}}</td>
                    <td>{{formatDate(car.createdAt)}}</td>
                    <td>{{formatDate(car.updatedAt)}}</td>
                    <td>{{car.status}}</td>
                    <td><img :src="car.user.pictureUrl" width="100"></td>
                    <td><a href="#" @click="msgUser=car.user;openSendMsg=true">{{car.user.displayName}}</a></td>
                  </tr>
                </template>
              </tbody>
          </table>
      </div><br><br>
      <h3 class="title" v-show="dataAlready" style="background-color:#eee;padding:15px;text-align:left;font-size:23px;">ข้อมูล Car</h3>
      <div class="container">
          <span v-show="!dataAlready && startSearch">Loading....</span>
          <table class="table is-striped" style="width:100%" v-show="dataAlready">
              <thead>
                  <tr>
                    <th><abbr title="name">ชื่อลูกค้า</abbr></th>
                    <th><abbr title="licenseNo">เลขทะเบียน</abbr></th>
                    <th><abbr title="userId">เลขเฟรม</abbr></th>
                    <th><abbr title="userId">รูป LINE</abbr></th>
                    <th><abbr title="userId">ชื่อ LINE</abbr></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="car in carList.item">
                  <tr v-bind:key="car.id" v-if="car.userId != '' && car.userId != '-1' ">
                    <td>{{car.customerName}}</td>
                    <td>{{car.licenseNo}}</td>
                    <td>{{car.frameNo}}</td>
                    <td><img :src="car.user.pictureUrl" width="100"></td>
                    <td><a href="#" @click="msgUser=car.user;openSendMsg=true">{{car.user.displayName}}</a></td>
                  </tr>
                </template>
              </tbody>
          </table>
      </div>
    </section>
    <div id="modal-js-example" :class="'modal ' + (openSendMsg ? 'is-active' : '')" v-if="msgUser">
      <div class="modal-background"></div>

      <div class="modal-content">
        <div class="box">
          <p>Send Message to <b>"{{msgUser.displayName}}"</b></p>
          <textarea class="textarea" placeholder="กรอกข้อความที่ต้องการส่ง" rows="5" cols="50" v-model="msg" ></textarea><br><br>
          <button class="button is-primary" @click="sendMsg" >Send</button>
          <!-- <button class="button is-success" @click="openLINEChat" >Open LINE Chat</button> -->
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="openSendMsg=false"></button>
    </div>
  </div>

</template>
<style scoped>
.banner {
  text-align: center;
  background-color: #000;
}
.hero-body {
  padding: 1.5rem 1.5rem !important;
}
.section {
  padding: 1rem .2rem !important;
}
.txt_small {
  font-size: 10px;
}
.section_form {
  width: 400px;
  margin: 0 auto;
}
</style>
<script>
export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {},
  data: () => ({
    dataAlready: false,
    startSearch: false,
    saving: false,
    carId: '',
    carList: [],
    jobList: [],
    jobBPList: [],
    frameNo: '',
    openSendMsg: false,
    msg: null,
    msgUser: null
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  methods: {
    openLINEChat () {
      window.open(`https://chat.line.biz/U0535cc2a39bd47fe80fac6671f68c309/chat/${this.msgUser.userId}`)
    },
    sendMsg () {
      if (this.msg !== null && this.msgUser !== null) {
        console.log(this.msgUser.userId)
        console.log([{type: 'text', text: this.msg}])
        this.$axios
          .post(`${this.$apiUrl}sendMessageToUser`,
            {
              to: this.msgUser.userId,
              msg: this.msg
            })
          .then(response => {
            alert('Send Success')
            this.msg = null
            this.msgUser = null
            this.openSendMsg = false
          })
      } else {
        alert('เกิดข้อผิดพลาดไม่สามารถส่งหา User คนนี้ได้')
        this.msg = null
        this.msgUser = null
        this.openSendMsg = false
      }
    },
    searchCar () {
      let _this = this
      this.carlist = []
      this.jobList = []
      this.startSearch = true
      this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}getJobFrameNo?frameNo=${_this.frameNo}`)
        .then(response => {
          _this.jobList = response.data
        })

      this.$axios
        .get(`${this.$apiUrl}getJobBPFrameNo?frameNo=${_this.frameNo}`)
        .then(response => {
          _this.jobBPList = response.data
        })

      this.$axios
        .get(`${this.$apiUrl}getCarProfileByFrameNo?frameNo=${_this.frameNo}`)
        .then(response => {
          _this.startSearch = false
          _this.dataAlready = true
          _this.carList = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchByFrame.vue